import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode(" No hay datos para mostrar ")
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "p-mb-3 font-bold" }, "Tipos", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "p-mb-3 font-bold" }, "Roles", -1)
const _hoisted_4 = { class: "p-multiselect-representative-option" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "p-mb-3 font-bold" }, "English Academy", -1)
const _hoisted_6 = { class: "p-mb-3 p-d-flex p-ai-center" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("label", { class: "p-ml-2" }, "Si", -1)
const _hoisted_8 = { class: "p-mb-1 p-d-flex p-ai-center" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("label", { class: "p-ml-2" }, "No", -1)
const _hoisted_10 = { class: "p-grid form-grid p-fluid" }
const _hoisted_11 = { class: "p-col-12 p-field" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("label", { for: "type" }, "Tipo", -1)
const _hoisted_13 = { class: "p-col-12 p-field" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("label", { for: "type" }, "Grupo", -1)
const _hoisted_15 = { class: "p-col-12 p-field" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("label", { for: "role" }, "Rol", -1)
const _hoisted_17 = { class: "p-col-12 p-field" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("label", { for: "type" }, "Valido por (meses)", -1)
const _hoisted_19 = { class: "p-d-flex p-jc-end" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!
  const _component_Toolbar = _resolveComponent("Toolbar")!
  const _component_MultiSelect = _resolveComponent("MultiSelect")!
  const _component_Column = _resolveComponent("Column")!
  const _component_Checkbox = _resolveComponent("Checkbox")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_InputNumber = _resolveComponent("InputNumber")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Toolbar, null, {
      end: _withCtx(() => [
        _createVNode(_component_Button, {
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.displayDialog = !_ctx.displayDialog)),
          label: "Nuevo",
          icon: "pi pi-plus",
          class: "p-button-success"
        })
      ]),
      _: 1
    }),
    _createVNode(_component_DataTable, {
      responsiveLayout: "scroll",
      filterDisplay: "menu",
      filters: _ctx.filters,
      "onUpdate:filters": _cache[1] || (_cache[1] = ($event: any) => (_ctx.filters = $event)),
      onPage: _cache[2] || (_cache[2] = ($event: any) => (_ctx.onPage($event))),
      onFilter: _cache[3] || (_cache[3] = ($event: any) => (_ctx.onFilter($event))),
      lazy: true,
      paginator: true,
      rows: _ctx.params.limit,
      rowsPerPageOptions: [20,50,100],
      totalRecords: _ctx.totalRecords,
      value: _ctx.contractTypes,
      loading: _ctx.loading,
      globalFilterFields: ['userName', 'createdAt', 'expirationDate', 'status', 'roles', 'groups']
    }, {
      empty: _withCtx(() => [
        _hoisted_1
      ]),
      default: _withCtx(() => [
        _createVNode(_component_Column, {
          header: "Tipo",
          field: "typeAlias",
          filterField: "type",
          style: {"min-width":"14rem"},
          filterMenuStyle: {'width':'18rem'},
          showFilterMatchModes: false,
          showFilterOperator: false,
          showAddButton: false
        }, {
          filter: _withCtx(({ filterModel }) => [
            _hoisted_2,
            _createVNode(_component_MultiSelect, {
              modelValue: filterModel.value,
              "onUpdate:modelValue": ($event: any) => (filterModel.value = $event),
              options: _ctx.typeOptions,
              optionValue: "value",
              optionLabel: "label",
              placeholder: "Tipo de contratos",
              class: "p-column-filter"
            }, {
              option: _withCtx((slotProps) => [
                _createElementVNode("div", null, [
                  _createElementVNode("span", null, _toDisplayString(slotProps.option.label), 1)
                ])
              ]),
              _: 2
            }, 1032, ["modelValue", "onUpdate:modelValue", "options"])
          ]),
          _: 1
        }),
        _createVNode(_component_Column, {
          header: "Rol",
          style: {"min-width":"14rem"},
          filterField: "role",
          field: "roleAlias",
          showFilterOperator: false,
          filterMenuStyle: {'width':'14rem'},
          showFilterMatchModes: false,
          showAddButton: false
        }, {
          filter: _withCtx(({ filterModel }) => [
            _hoisted_3,
            _createVNode(_component_MultiSelect, {
              modelValue: filterModel.value,
              "onUpdate:modelValue": ($event: any) => (filterModel.value = $event),
              options: _ctx.roleFilterOptions,
              optionValue: "value",
              optionLabel: "name",
              placeholder: "Rol",
              class: "p-column-filter"
            }, {
              option: _withCtx((slotProps) => [
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("span", null, _toDisplayString(slotProps.option.name), 1)
                ])
              ]),
              _: 2
            }, 1032, ["modelValue", "onUpdate:modelValue", "options"])
          ]),
          _: 1
        }),
        _createVNode(_component_Column, {
          header: "Grupo",
          style: {"min-width":"14rem"},
          filterField: "group",
          field: "group",
          showFilterOperator: false,
          filterMenuStyle: {'width':'14rem'},
          showFilterMatchModes: false,
          showAddButton: false
        }, {
          filter: _withCtx(({ filterModel }) => [
            _hoisted_5,
            _createElementVNode("div", _hoisted_6, [
              _createVNode(_component_Checkbox, {
                modelValue: filterModel.value,
                "onUpdate:modelValue": ($event: any) => (filterModel.value = $event),
                value: "EnglishAcademy"
              }, null, 8, ["modelValue", "onUpdate:modelValue"]),
              _hoisted_7
            ]),
            _createElementVNode("div", _hoisted_8, [
              _createVNode(_component_Checkbox, {
                modelValue: filterModel.value,
                "onUpdate:modelValue": ($event: any) => (filterModel.value = $event),
                value: "Regular"
              }, null, 8, ["modelValue", "onUpdate:modelValue"]),
              _hoisted_9
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_Column, {
          header: "Meses de validez",
          field: "monthlyLife"
        }),
        _createVNode(_component_Column, {
          header: "Fecha de creación",
          style: {"min-width":"14rem"}
        }, {
          body: _withCtx(({
          data: {
            createdAt,
          },
        }) => [
            _createTextVNode(_toDisplayString(_ctx.formatDate(createdAt, _ctx.FormatDates.LatinAmerica)), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_Column, { header: "Acciones" }, {
          body: _withCtx(({ data }) => [
            _createVNode(_component_Button, {
              loading: _ctx.loadingRoleOptions && (_ctx.editingContractType?.id === data.id),
              onClick: ($event: any) => (_ctx.edit(data)),
              icon: "pi pi-pencil"
            }, null, 8, ["loading", "onClick"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["filters", "rows", "totalRecords", "value", "loading"]),
    _createVNode(_component_Dialog, {
      header: _ctx.editingContractType ? 'Editando tipo de contrato' : 'Creando tipo de contrato',
      modal: true,
      style: { width: '50vw' },
      visible: _ctx.displayDialog,
      "onUpdate:visible": _cache[9] || (_cache[9] = ($event: any) => (_ctx.displayDialog = $event)),
      onHide: _ctx.onHideDialog
    }, {
      default: _withCtx(() => [
        _createElementVNode("form", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, [
            _hoisted_12,
            _createVNode(_component_Dropdown, {
              placeholder: "Seleccione un tipo..",
              modelValue: _ctx.formValue.type,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.formValue.type = $event)),
              options: _ctx.typeOptions,
              optionLabel: "label",
              optionValue: "value"
            }, null, 8, ["modelValue", "options"])
          ]),
          _createElementVNode("div", _hoisted_13, [
            _hoisted_14,
            _createVNode(_component_Dropdown, {
              placeholder: "Seleccione un grupo...",
              modelValue: _ctx.formValue.group,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.formValue.group = $event)),
              onChange: _cache[6] || (_cache[6] = ($event: any) => (_ctx.loadRoleOptions(_ctx.formValue.group, _ctx.formValue.type))),
              options: _ctx.groupOptions,
              optionLabel: "label",
              optionValue: "value"
            }, null, 8, ["modelValue", "options"])
          ]),
          _createElementVNode("div", _hoisted_15, [
            _hoisted_16,
            _createVNode(_component_Dropdown, {
              placeholder: !_ctx.roleOptions.length ? 'Complete primero los campos Tipo y Grupo...' : 'Seleccione un rol...',
              disabled: !_ctx.roleOptions.length,
              modelValue: _ctx.formValue.role,
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.formValue.role = $event)),
              loading: _ctx.loadingRoleOptions,
              options: _ctx.roleOptions,
              optionLabel: "label",
              optionValue: "value"
            }, null, 8, ["placeholder", "disabled", "modelValue", "loading", "options"])
          ]),
          _createElementVNode("div", _hoisted_17, [
            _hoisted_18,
            _createVNode(_component_InputNumber, {
              showButtons: "",
              mode: "decimal",
              useGrouping: false,
              placeholder: "Indique la cantidad de meses de validez de este tipo de contratos...",
              modelValue: _ctx.formValue.monthlyLife,
              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.formValue.monthlyLife = $event)),
              min: 0
            }, null, 8, ["modelValue"])
          ])
        ]),
        _createElementVNode("div", _hoisted_19, [
          _createVNode(_component_Button, {
            loading: _ctx.creatingContractType,
            onClick: _ctx.upsertContractType,
            disabled: _ctx.v$.$invalid,
            type: "submit",
            label: "Guardar"
          }, null, 8, ["loading", "onClick", "disabled"])
        ])
      ]),
      _: 1
    }, 8, ["header", "visible", "onHide"])
  ], 64))
}